const columns = [
  {
    swapFreeIslamic: "YES",

    title: 'Plan Name',
    dataIndex: 'planName',

  },
  {
    title: 'Group Name',
    dataIndex: 'groupName',

  },
  {
    title: 'Commission',
    dataIndex: 'groupCommission',

  },
  {
    title: 'Minimum Deposit',
    dataIndex: 'minimumDeposit',

  },
  {
    title: 'IB Comission',
    dataIndex: 'commission',
  },
  {
    title: 'Leverage',
    dataIndex: 'leverage',
  },
  // {
  //   title: 'Swap Free',
  //   dataIndex: 'swapFree',
  // },
  {
    title: 'ThresHold',
    dataIndex: 'threshHold',
  },
  {
    title: 'Account Type',
    dataIndex: 'accType',
  },
  {
    title: 'Status',
    dataIndex: 'status',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
  }

];

export default columns;


